import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'aig-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
})
export class BannerComponent implements OnInit {
  @Input() info!: {
    image: string;
    alt: string
  }
  constructor() { }

  ngOnInit() {
  }

}
